document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".custom-login-popup");

  function handleLoginPopup(action) {
    if (!popup) return;

    if (action === "open") {
      popup.classList.remove("hidden");
    } else if (action === "close") {
      popup.classList.add("hidden");
    }
  }

  // Shopify 会在页面上提供全局变量 customer，检查是否已登录
  const isLoggedIn = document.body.classList.contains("customer-logged-in"); 

  // 仅在未登录用户访问 /account/ 页面时显示弹窗
  if (!isLoggedIn && window.location.pathname.includes("/account/")) {
    handleLoginPopup("open");
  }

  // 事件委托，确保 Shopify 渲染的按钮可以触发弹窗
  document.body.addEventListener("click", function (event) {
    // 处理 "打开弹窗" 按钮点击
    if (event.target.closest(".login-button")) {
      handleLoginPopup("open");
    }

    // 处理 "关闭弹窗" 按钮点击
    if (event.target.closest(".close-btn")) {
      handleLoginPopup("close");
    }
  });
});
